export default {
    namespaced: true,
    state: {
        isActive: false,
        sourceGroupId: 0,
        destinationGroups: [],
        courses: [],
        currentCourseIndex: 0,
        copiedCourses: [],
        failedCourses: [],
        phase: '', // 'courses' or 'group-elements'
        error: null,
        isCompleted: false,
        isModalOpen: false
    },

    getters: {
        progress: (state) => {
            if (!state.courses.length) return 0
            return Math.round((state.currentCourseIndex / state.courses.length) * 100)
        },

        currentCourse: (state) => {
            if (state.currentCourseIndex >= state.courses.length) return null
            return state.courses[state.currentCourseIndex]
        },

        totalCourses: (state) => state.courses.length,

        isInProgress: (state) => state.isActive && !state.isCompleted,

        hasErrors: (state) => state.failedCourses.length > 0,

        progressInfo: (state, getters) => {
            if (state.phase === 'group-elements') {
                return {
                    type: 'group-elements',
                    key: 'Copying group settings, apps, and other elements...'
                }
            }

            const current = getters.currentCourse
            if (!current) {
                return {
                    type: 'starting',
                    key: 'Starting...'
                }
            }

            return {
                type: 'copying-course',
                key: 'Copying course',
                params: {
                    current: state.currentCourseIndex + 1,
                    total: state.courses.length,
                    title: current.title || current.name
                }
            }
        }
    },

    mutations: {
        START_COPY(state, { sourceGroupId, destinationGroups, courses }) {
            state.isActive = true
            state.sourceGroupId = sourceGroupId
            state.destinationGroups = destinationGroups
            state.courses = courses
            state.currentCourseIndex = 0
            state.copiedCourses = []
            state.failedCourses = []
            state.phase = 'courses'
            state.error = null
            state.isCompleted = false
            state.isModalOpen = true
        },

        COURSE_COPY_SUCCESS(state, { courseIndex, newObjectId }) {
            const course = state.courses[courseIndex]
            state.copiedCourses.push({
                ...course,
                newObjectId
            })
            state.currentCourseIndex = courseIndex + 1
        },

        COURSE_COPY_FAILED(state, { courseIndex, error }) {
            const course = state.courses[courseIndex]
            state.failedCourses.push({
                ...course,
                error: error.message || 'Unknown error'
            })
            state.currentCourseIndex = courseIndex + 1
        },

        SET_PHASE(state, phase) {
            state.phase = phase
        },

        SET_ERROR(state, error) {
            state.error = error
        },

        COMPLETE_COPY(state, success = true) {
            state.isCompleted = true
            state.isActive = false
            if (!success) {
                state.error = 'Copy operation completed with errors'
            }
        },

        RESET_COPY(state) {
            state.isActive = false
            state.sourceGroupId = 0
            state.destinationGroups = []
            state.courses = []
            state.currentCourseIndex = 0
            state.copiedCourses = []
            state.failedCourses = []
            state.phase = ''
            state.error = null
            state.isCompleted = false
            state.isModalOpen = false
        },

        CLOSE_MODAL(state) {
            state.isModalOpen = false
        },

        RETRY_FAILED_COURSE(state, courseIndex) {
            // Remove course from failed list and reset it for retry
            const globalCourseIndex = state.courses.findIndex(
                course => course === state.failedCourses[courseIndex]
            )
            state.failedCourses.splice(courseIndex, 1)
            // Don't modify currentCourseIndex as we'll handle retry manually
        }
    },

    actions: {
        startCopy({ commit }, payload) {
            commit('START_COPY', payload)
        },

        courseSuccess({ commit }, payload) {
            commit('COURSE_COPY_SUCCESS', payload)
        },

        courseFailed({ commit }, payload) {
            commit('COURSE_COPY_FAILED', payload)
        },

        setPhase({ commit }, phase) {
            commit('SET_PHASE', phase)
        },

        setError({ commit }, error) {
            commit('SET_ERROR', error)
        },

        completeCopy({ commit }, success = true) {
            commit('COMPLETE_COPY', success)
        },

        resetCopy({ commit }) {
            commit('RESET_COPY')
        },

        closeModal({ commit }) {
            commit('CLOSE_MODAL')
        },

        retryFailedCourse({ commit }, courseIndex) {
            commit('RETRY_FAILED_COURSE', courseIndex)
        }
    }
}